import { createClient } from "@supabase/supabase-js";

// Utilisation des variables d'environnement pour la sécurité
export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
export const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Configuration Supabase manquante dans le fichier .env");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

const SUPABASE_STORAGE_PUBLIC_BASE = `${supabaseUrl}/storage/v1/object/public`;

/**
 * Construit l'URL publique directe d'un fichier stocké dans Supabase Storage (mode PUBLIC)
 * de manière synchrone, sans aucun appel réseau ni méthode SDK (getPublicUrl).
 * Gère les chemins relatifs (ex: "userId/avatar.webp"), les URLs absolues (OAuth, CDN, blob, data),
 * et permet le versioning pour l'invalidation du cache navigateur (?v=timestamp).
 */
export const getPublicStorageUrl = (
  pathOrUrl?: string | null,
  bucket: string = "avatars",
  version?: number | string
): string => {
  if (!pathOrUrl || typeof pathOrUrl !== "string") return "";
  const trimmed = pathOrUrl.trim();
  if (!trimmed) return "";

  // Support direct des assets statiques locaux du dossier /public (ex: /mock/ambre.webp)
  if (
    trimmed.startsWith("/mock/") ||
    trimmed.startsWith("mock/") ||
    trimmed.startsWith("/public/") ||
    trimmed.startsWith("./") ||
    trimmed.startsWith("/assets/")
  ) {
    const localPath = trimmed.startsWith("mock/")
      ? `/${trimmed}`
      : trimmed.replace(/^\/public\//, "/");
    return version !== undefined && version !== null && version !== ""
      ? `${localPath}${localPath.includes("?") ? "&" : "?"}v=${version}`
      : localPath;
  }

  let url = trimmed;
  if (
    !trimmed.startsWith("http://") &&
    !trimmed.startsWith("https://") &&
    !trimmed.startsWith("data:") &&
    !trimmed.startsWith("blob:")
  ) {
    const cleanPath = trimmed.replace(/^\/+/, "");
    if (cleanPath.startsWith(`${bucket}/`)) {
      url = `${SUPABASE_STORAGE_PUBLIC_BASE}/${cleanPath}`;
    } else {
      url = `${SUPABASE_STORAGE_PUBLIC_BASE}/${bucket}/${cleanPath}`;
    }
  }

  if (version !== undefined && version !== null && version !== "") {
    if (/[?&]v=/.test(url)) {
      url = url.replace(/([?&])v=[^&]*/, `$1v=${version}`);
    } else {
      const sep = url.includes("?") ? "&" : "?";
      url = `${url}${sep}v=${version}`;
    }
  }

  return url;
};
